module.exports = __webpack_public_path__ + "images/b857d759d01a51da7b978cf8db31add34d9c831f55ae957aac67074b61333c50.svg";